<template>
  <div class="app-main-content">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%">
        <el-tab-pane v-if="!isUsePeriodRate" :label="$t('CargoMsg.Cargo_ChargeRate')" name="chargeRate" :lazy="true" no="chargeRate">
          <charge-rate />
        </el-tab-pane>
        <el-tab-pane v-if="isUsePeriodRate" :label="chargeRateLable" name="ratePeriod" :lazy="true" no="ratePeriod">
          <rate-period :hq-rate="true" />
        </el-tab-pane>
        <el-tab-pane v-if="isUsePeriodRate && isBranchRate && $checkPermission(['tab_SMRate_officeRate'])" :label="$t('CargoMsg.Cargo_BranchRate')" name="ratePeriodBranch" :lazy="true" no="ratePeriodBranch">
          <rate-period :hq-rate="false" />
        </el-tab-pane>
        <el-tab-pane v-if="isSaveBillRate" :label="$t('CargoMsg.Cargo_BillingRate')" name="billingRate" :lazy="true" no="billingRate">
          <billing-rate />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import chargeRate from './chargeRate'
import billingRate from './billingRate'
import ratePeriod from './ratePeriod'
import { cacheName, cache } from '@/utils/cacheManager'

export default {
  name: 'RateManagement',
  components: { chargeRate, billingRate, ratePeriod },
  data() {
    return {
      activeTabName: 'chargeRate',
      isSaveBillRate: false,
      usePeriodRate: false,
      branchRate: false // 是否分公司独立汇率
    }
  },
  computed: {
    isUsePeriodRate() {
      return this.usePeriodRate
    },
    isBranchRate() {
      return this.branchRate
    },
    chargeRateLable() {
      return this.isBranchRate ? this.$t('CargoMsg.Cargo_GroupChargeRate') : this.$t('CargoMsg.Cargo_ChargeRate')
    }
  },
  async beforeMount() {
    await cache.load(cacheName.CONFIG)
    this.isSaveBillRate = Number(cache.config.get('isSaveBillRate')) === 1
    this.usePeriodRate = Number(cache.config.get('usePeriodRate')) === 1
    this.branchRate = Number(cache.config.get('BranchExchangeRate')) === 1
    if (this.usePeriodRate) this.activeTabName = 'ratePeriod'
  }
}
String.prototype.format = function() {
  if (arguments.length == 0) return this
  for (var s = this, i = 0; i < arguments.length; i++) {
    s = s.replace(new RegExp('\\{' + i + '\\}', 'g'), arguments[i])
  }
  return s
}
</script>

<style scoped>

</style>
